import React, { useState, useEffect, useRef } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import ModalHeader from "../../../common/ModalHeader";
import ModalFooter from "../../../common/ModalFooter";
import ModalBody from "../../../common/ModalBody";
import { useTranslation } from "react-i18next";
import Constants from "../../../../common/Constants";
import { ConfirmationModal } from "../../../common/ConfirmationModal";
import { DropdownListField } from "../../../../common/formElements/DropdownListField";
import { useSelector, useDispatch } from "react-redux";
import { fetchMasterList } from "../../../../redux/feature/manufacturing_app/commonMasterListSlice";

const ProcessModal = (props) => {
  let deptList = useSelector(
    (state) => state?.masterList?.page[Constants.MASTER.DEPARTMENT.name]?.data
  ); // User Details from Store

  // let [processOrder, setProcessOrder] = useState("");
  let [edit, setEdit] = useState(false);
  const [validate, setValidate] = useState(false);
  // let [status, setProcessStatus] = useState("Active");
  const { t } = useTranslation();
  const formRef = useRef(null);
  const [statusConfirmModel, setStatusConfirmModel] = useState(false);
  let [deptCode, setDeptCode] = useState();
  let [deptName, setDeptName] = useState();
  let [cycleTime, setCycleTime] = useState();

  const dispatch = useDispatch();

  useEffect(() => {
    if (props?.data?.processOrder) {
      // setProcessOrder(props?.data?.processOrder)
      setDeptCode(props?.data?.deptCode);
      setDeptName(props?.data?.deptName);
      setCycleTime(props?.data?.cycleTime);
      // setProcessStatus(props?.data?.processStatus)
      setEdit(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleProcessSave = (event) => {
    const form = formRef.current;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setValidate(true);
      return;
    } else {
      setValidate(false);
      const deptObj = {
        deptCode: deptCode,
        deptName: deptName,
        cycleTime: cycleTime,
        processOrder: form[0].value,
      };
      if (edit) {
        deptObj._id = props.data._id;
      }
      props.onSave(deptObj, edit);
      // setProcessOrder('')
      setDeptCode("");
      setDeptName("");
      setCycleTime("");
      setEdit(true);
    }
  };

  const handleProcessFormCancel = (event) => {
    // setProcessOrder('')
    setDeptCode("");
    setDeptName("");
    props.onHide();
  };

  useEffect(() => {
    if (!deptList) {
      dispatch(fetchMasterList(Constants.MASTER.DEPARTMENT));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deptList]);

  const deptResult =
    deptList &&
    deptList.map(({ deptCode, deptName }) => ({ deptCode, deptName: `${deptCode} - ${deptName}` }));

  const deptCodeList = props?.rowData?.map((entry) => entry.deptCode);

  const filteredDepartments = deptResult?.filter(
    (department) => !deptCodeList?.includes(department?.deptCode)
  );

  const { show, onHide, rowData } = props;
  return (
    <>
      <Modal
        show={show}
        onHide={onHide}
        animation={false}
        backdrop="static"
        className="secondModal"
      >
        <ModalHeader
          title={edit? t("msg_master_list.msg_process.edit_page_title") : t("msg_master_list.msg_process.page_title")}
        ></ModalHeader>
        <ModalBody>
          <Form noValidate validated={validate} ref={formRef}>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label className="col-form-label">
                {t("msg_master_list.msg_process.code")} :
              </Form.Label>
              <Form.Control
                type="text"
                //placeholder="e.g: DEPT-001"
                value={rowData ? rowData?.length + 1 : 1}
                //onChange={(e) => setId(e.target.value.trim())}
                required
                //maxLength={Constants.MASTER.VALIDATION.maxLengthCode}
                disabled
              />
              <Form.Control.Feedback type="invalid">
                {t("msg_master_list.msg_process.process_code_validation")}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label className="col-form-label">
                {" "}
                {t("msg_master_list.msg_process.process_name")} :
              </Form.Label>
              <DropdownListField
                id="deptCode"
                name="deptName"
                className="dropdownHive w-full rounded-md"
                data={filteredDepartments}
                value={deptCode}
                onChange={(value) => {setDeptCode(value?.deptCode);setDeptName(value?.deptName);}}
                placeholder={t(
                  "msg_master_list.msg_machines.select_department"
                )}
                autoFocus={true}
                disabled={!filteredDepartments}
              />
              <Form.Control.Feedback type="invalid">
                {t("msg_master_list.msg_process.process_name_validation")}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label className="col-form-label">
                {t("msg_master_list.msg_process.cycle_time")} :
              </Form.Label>
              <Form.Control
                type="text"
                //placeholder="e.g: DEPT-001"
                value={cycleTime}
                onChange={(e) => setCycleTime(e.target.value)}
                required
              />
              <Form.Control.Feedback type="invalid">
                {t("msg_master_list.msg_process.process_cycleTime_validation")}
              </Form.Control.Feedback>
            </Form.Group>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button
            type="button"
            variant="success"
            className="btn btn-success"
            onClick={handleProcessSave}
          >
            {t("msg_common.save")}
          </Button>
          <Button
            type="button"
            variant="danger"
            className="btn btn-danger"
            onClick={handleProcessFormCancel}
            data-dismiss="modal"
          >
            {t("msg_common.cancel")}
          </Button>
        </ModalFooter>
      </Modal>

      {statusConfirmModel && (
        <ConfirmationModal
          show={statusConfirmModel}
          heading={t("msg_common.confirmation")}
          bodyMessage={t("msg_master_list.msg_process.status_change_message")}
          onOk={() => setStatusConfirmModel(false)}
          onHide={() => setStatusConfirmModel(false)}
          type={"common"}
        ></ConfirmationModal>
      )}
    </>
  );
};

export default ProcessModal;
